"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SongwriterCatalogBuilderHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null,
        "Enter the writer name you wish to ",
        react_1.default.createElement("strong", null, "search"),
        " in the Writer Name section, then click the Search button. From the results, select all versions of the writer name that you have the rights to by clicking the",
        ' ',
        react_1.default.createElement("strong", null, "Add to Catalog"),
        " button."),
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null, "Before selecting, please confirm it is the correct writer name by reviewing the associated IPI Number or clicking the blue linked \"[X] titles\" to see works associated with that name.")));
exports.default = SongwriterCatalogBuilderHeader;
